//============ wy.core.services.evaluatemge.EvaluateRankResultQueryPara =============
/* eslint-disable camelcase */
import {QueryParameter} from '@/base/QueryParameter';

export class EvaluateRankResultQueryPara extends QueryParameter {
    constructor() {
        super();
    }

    _QueryAttr_Id = 'id';
    _QueryAttr_CantonCode = 'cantonCode';
    _QueryAttr_EvaluateObjType = 'evaluateObjType';
    _QueryAttr_OrgCode = 'orgCode';
    _QueryAttr_Year = 'year';
    _QueryAttr_Month = 'month';
    _QueryAttr_Average = 'average';
    _QueryAttr_RankType = 'rankType';
    _QueryAttr_Rank = 'rank';
    _OrderAttr_Id = 'id';
    _OrderAttr_CantonCode = 'cantonCode';
    _OrderAttr_EvaluateObjType = 'evaluateObjType';
    _OrderAttr_OrgCode = 'orgCode';
    _OrderAttr_Year = 'year';
    _OrderAttr_Month = 'month';
    _OrderAttr_Average = 'average';
    _OrderAttr_RankType = 'rankType';
    _OrderAttr_Rank = 'rank';


    /*cantonCodes:String[]*/
    setParamByCantonCode_Enum(cantonCodes) {
        this.addParameterByEnum(this._QueryAttr_CantonCode, cantonCodes);
    }

    /*orgCode:String*/
    setParamByOrgCode(orgCode) {
        this.addParameter(this._QueryAttr_OrgCode, orgCode);
    }

    /*orgCodes:String[]*/
    setParamByOrgCode_Enum(orgCodes) {
        this.addParameterByEnum(this._QueryAttr_OrgCode, orgCodes);
    }

    /*cantonCode:String*/
    setParamByCantonCode(cantonCode) {
        this.addParameter(this._QueryAttr_CantonCode, cantonCode);
    }

    /*evaluateObjType:int*/
    setParamByEvaluateObjType(evaluateObjType) {
        this.addParameter(this._QueryAttr_EvaluateObjType, evaluateObjType);
    }

    /*year:int*/
    setParamByYear(year) {
        this.addParameter(this._QueryAttr_Year, year);
    }

    /*month:int*/
    setParamByMonth(month) {
        this.addParameter(this._QueryAttr_Month, month);
    }

    /*rankType:int*/
    setParamByRankType(rankType) {
        this.addParameter(this._QueryAttr_RankType, rankType);
    }

    /*evaluateObjType:int*/
    setParamByEvaluateObjTypeIncZero(evaluateObjType) {
        this.addParameterIncZero(this._QueryAttr_EvaluateObjType, evaluateObjType);
    }

    /*low:int, high:int*/
    setParamByEvaluateObjType_Range(low, high) {
        this.addNumberParameterByRange(this._QueryAttr_EvaluateObjType, low, high);
    }

    /*evaluateObjTypes:int[]*/
    setParamByEvaluateObjType_Enum(evaluateObjTypes) {
        this.addParameterByEnum(this._QueryAttr_EvaluateObjType, evaluateObjTypes);
    }

    /*low:int, high:int*/
    setParamByRank_Range(low, high) {
        this.addNumberParameterByRange(this._QueryAttr_Rank, low, high);
    }

    /*low:BigDecimal, high:BigDecimal*/
    setParamByAverage_Range(low, high) {
        this.addNumberParameterByRange(this._QueryAttr_Average, low, high);
    }

    /*average:BigDecimal*/
    setParamByAverageIncZero(average) {
        this.addParameterIncZero(this._QueryAttr_Average, average);
    }

    /*low:int, high:int*/
    setParamByRankType_Range(low, high) {
        this.addNumberParameterByRange(this._QueryAttr_RankType, low, high);
    }

    /*months:int[]*/
    setParamByMonth_Enum(months) {
        this.addParameterByEnum(this._QueryAttr_Month, months);
    }

    /*averages:BigDecimal[]*/
    setParamByAverage_Enum(averages) {
        this.addParameterByEnum(this._QueryAttr_Average, averages);
    }

    /*average:BigDecimal*/
    setParamByAverage(average) {
        this.addParameter(this._QueryAttr_Average, average);
    }

    /*ranks:int[]*/
    setParamByRank_Enum(ranks) {
        this.addParameterByEnum(this._QueryAttr_Rank, ranks);
    }

    /*low:int, high:int*/
    setParamByMonth_Range(low, high) {
        this.addNumberParameterByRange(this._QueryAttr_Month, low, high);
    }

    /*rankType:int*/
    setParamByRankTypeIncZero(rankType) {
        this.addParameterIncZero(this._QueryAttr_RankType, rankType);
    }

    /*year:int*/
    setParamByYearIncZero(year) {
        this.addParameterIncZero(this._QueryAttr_Year, year);
    }

    /*month:int*/
    setParamByMonthIncZero(month) {
        this.addParameterIncZero(this._QueryAttr_Month, month);
    }

    /*rank:int*/
    setParamByRankIncZero(rank) {
        this.addParameterIncZero(this._QueryAttr_Rank, rank);
    }

    /*years:int[]*/
    setParamByYear_Enum(years) {
        this.addParameterByEnum(this._QueryAttr_Year, years);
    }

    /*rankTypes:int[]*/
    setParamByRankType_Enum(rankTypes) {
        this.addParameterByEnum(this._QueryAttr_RankType, rankTypes);
    }

    /*low:int, high:int*/
    setParamByYear_Range(low, high) {
        this.addNumberParameterByRange(this._QueryAttr_Year, low, high);
    }

    /*ids:String[]*/
    setParamById_Enum(ids) {
        this.addParameterByEnum(this._QueryAttr_Id, ids);
    }

    /*id:String*/
    setParamById(id) {
        this.addParameter(this._QueryAttr_Id, id);
    }

    /*rank:int*/
    setParamByRank(rank) {
        this.addParameter(this._QueryAttr_Rank, rank);
    }

}